import { render } from "./PosterForm.vue?vue&type=template&id=575882f5"
import script from "./PosterForm.vue?vue&type=script&lang=js"
export * from "./PosterForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__